import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { MentionsProviderQuery } from './MentionsProviderQuery.graphql.ts';
import type { MentionsProviderQuery as MentionsProviderQueryType } from './__types__/MentionsProviderQuery.ts';

export const preloadMentionsProvider = async () =>
	query<MentionsProviderQueryType, {}>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: MentionsProviderQuery,
	});
